"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Ajax = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _config = require("./config");
var _utils = require("./utils");
var _redirect = require("./redirect");
/**
 * @example
 * ```typescript
 * Ajax.get('/settings').then(...);
 * 
 * // pass data
 * Ajax.get('/api/v1/users', { page: 1, limit: 10 }).then(...);
 * Ajax.post('/api/v1/users', { name: 'John' }).then(...);
 * 
 * // pass custom config
 * Ajax.get('/secrets', {}, {
 * 	headers: { ... },	
 * 	redirect: {
 * 		403: '/unauthorized',
 * 	}
 * }).then(...)
 */
class Ajax {
  /**
   * Class Ajax abstraction layer making Ajax HTTP requests fun and easy
   * @param {object} lib HTTP Request library to be used in requests
   * @param {string} name Name of instance to be created
   * @param {object} config This is an optional configuration object to specify a base config for this instance
   * @constructor
   */
  constructor(lib = {}, name = '', config = {}) {
    this.name = name;
    this.originalConfig = config;
    this.instanceConfig = (0, _utils.createConfig)(config);
    this.lib = lib;
    this.instance = lib.create ? lib.create(this.instanceConfig) : lib;
  }

  /**
   * Passthrough of Promise.all
   */
  all(promises) {
    return _promise.default.all(promises);
  }

  /**
   * Passthrough of lib.CancelToken.source()
   * Creates a token and canel method which are returned to use in a request
   * @returns {object} Object containing token and cancel function
   */
  createCancelSource() {
    return this.lib.CancelToken.source();
  }

  /**
   * Passthrough of lib.isCancel
   * Checks to see if prototype of value parameter contains Cancel property
   * to determine if promise rejection is cancelled from Axios
   * @param {object} value Object to check if is cancelled by Axios
   */
  isCancelledReason(value) {
    return this.lib.isCancel(value);
  }

  /**
   * Request method to handle supported methods, data, configuration, etc.
   * @param {(object|string)} config An object representing the configuration, or the URL as a string, forcing the configruation to the second parameter
   * @returns {Promise} Promise to be resolved if successful
   * @throws {(Error|TypeError)} Will throw if unsupported method is provided, no URL or no method is provided
   */
  request(config) {
    return new _promise.default((resolve, reject) => {
      if ((0, _isString2.default)(config)) {
        config = arguments[1] || {};
        config.url = arguments[0];
      } else {
        if ((0, _isPlainObject2.default)(arguments[0]) && (0, _isPlainObject2.default)(arguments[1])) {
          config = arguments[1];
          config.urlParams = arguments[0];
        } else {
          config = config || {};
        }
      }
      config.method = config.method || config.type || 'get';
      if ((0, _isUndefined2.default)(config.transformRequest) && !(0, _isUndefined2.default)(config.serializeArray)) {
        config.transformRequest = [(0, _utils.transformRequestData)({
          ...this.instanceConfig,
          ...config
        })];
      }
      config = {
        headers: (0, _utils.clearBlacklistedHeaders)(config.headers),
        ...(0, _cloneDeep2.default)(this.instanceConfig),
        ...config,
        method: config.method.toLowerCase()
      };
      config = (0, _utils.prepareRequestUrl)(config);
      if (config.urlError) {
        return reject(new Error('Unable to prepare request url. Look at baseURL and urlParams for more information', config.urlError));
      }
      if ((0, _isUndefined2.default)(config.url) || !(0, _isString2.default)(config.url)) {
        return reject(new TypeError('Invalid URL was supplied'));
      }
      if (!config.method || !(0, _isString2.default)(config.method)) {
        return reject(new TypeError('Invalid method was supplied'));
      }
      if (!(0, _includes.default)(_config.SUPPORTED_METHODS).call(_config.SUPPORTED_METHODS, config.method)) {
        const errorMessage = `Unsupported method type '${config.method}'`;
        return reject(new Error(errorMessage));
      }
      config.headers['X-CSRF-TOKEN'] = window.CSRF_TOKEN;
      if (_config.rNoContent.test(config.method)) {
        if (config.data) {
          config.url = (0, _utils.buildUrl)(config.url, config.data);
          delete config.data;
        }
        delete config.headers['X-CSRF-TOKEN'];
      }
      if ((0, _isUndefined2.default)(config.data) || (0, _isPlainObject2.default)(config.data) && (0, _isEmpty2.default)((0, _keys.default)(config.data))) {
        delete config.data;
      }
      resolve(this.instance.request(config));
    }).catch(error => {
      if (config.redirect) {
        const status = error?.response?.status;
        if (!status) {
          throw error;
        }
        const redirected = (0, _redirect.redirect)(status, config.redirect, config.redirectOptions);
        if (!redirected) {
          throw error;
        }
        return;
      }
      throw error;
    });
  }

  /**
   * Spread function meant to mimic Promise.spread
   * @param {function} callback A callback function to handle array of arguments as flattened parameters
   */
  spread(callback) {
    return (...args) => {
      return callback(...args);
    };
  }
}

// Provide aliases for supported request methods
exports.Ajax = Ajax;
(0, _forEach.default)(_config.SUPPORTED_METHODS).call(_config.SUPPORTED_METHODS, function forEachMethodWithData(method) {
  Ajax.prototype[method] = function (url, data = null, config = {}) {
    let requestObject = {};
    if ((0, _isPlainObject2.default)(url)) {
      requestObject = url;
    } else {
      requestObject = {
        ...config,
        method,
        url,
        data
      };
    }
    return this.request(requestObject);
  };
});